<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <div class="text-center">
        <h1 class="text-4xl font-bold text-gray-900 mb-4">MARBEL</h1>
        <p class="text-xl text-gray-600 mb-8">Bienvenido al Portal de Servicios</p>
      </div>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-lg">
      <div class="bg-white py-8 px-4 shadow-xl rounded-lg sm:px-10">
        <div class="space-y-6">
          <!-- Auto Facturación -->
          <div class="border rounded-lg p-6 hover:shadow-md transition-shadow">
            <div class="flex items-center mb-4">
              <div class="flex-shrink-0">
                <svg class="h-8 w-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
              </div>
              <div class="ml-4">
                <h3 class="text-lg font-medium text-gray-900">Auto Facturación</h3>
                <p class="text-sm text-gray-500">Genera tu factura de manera fácil y rápida</p>
              </div>
            </div>
            <router-link
              to="/facturacion"
              class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Generar Factura
            </router-link>
          </div>

          <!-- Facturación Cliente (flujo real) -->
          <div class="border rounded-lg p-6 hover:shadow-md transition-shadow">
            <div class="flex items-center mb-4">
              <div class="flex-shrink-0">
                <svg class="h-8 w-8 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
                </svg>
              </div>
              <div class="ml-4">
                <h3 class="text-lg font-medium text-gray-900">Facturación Cliente</h3>
                <p class="text-sm text-gray-500">Accede con tu teléfono para facturar tus órdenes</p>
              </div>
            </div>
            <router-link
              to="/facturacion-cliente"
              class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500"
            >
              Ingresar al Portal
            </router-link>
          </div>

          <!-- Soporte -->
          <div class="border rounded-lg p-6">
            <div class="flex items-center mb-4">
              <div class="flex-shrink-0">
                <svg class="h-8 w-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 2.25a9.75 9.75 0 11-9.75 9.75A9.75 9.75 0 0112 2.25z"></path>
                </svg>
              </div>
              <div class="ml-4">
                <h3 class="text-lg font-medium text-gray-900">Soporte</h3>
                <p class="text-sm text-gray-500">¿Necesitas ayuda? Contáctanos</p>
              </div>
            </div>
            <div class="space-y-2">
              <p class="text-sm text-gray-600">
                <strong>Teléfono:</strong> 
                <a href="tel:+1234567890" class="text-green-600 hover:text-green-500">123-456-7890</a>
              </p>
              <p class="text-sm text-gray-600">
                <strong>Email:</strong> 
                <a href="mailto:soporte@marbel.com" class="text-green-600 hover:text-green-500">soporte@marbel.com</a>
              </p>
              <p class="text-sm text-gray-600">
                <strong>Horario:</strong> Lun-Vie 9:00 AM - 6:00 PM
              </p>
            </div>
          </div>

          <!-- Información -->
          <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div class="flex">
              <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
                </svg>
              </div>
              <div class="ml-3">
                <h3 class="text-sm font-medium text-blue-800">Información Importante</h3>
                <div class="mt-2 text-sm text-blue-700">
                  <p>Para generar tu factura necesitarás:</p>
                  <ul class="list-disc list-inside mt-1">
                    <li>Número de orden</li>
                    <li>RFC válido</li>
                    <li>Datos fiscales completos</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="mt-12 text-center">
      <p class="text-sm text-gray-500">
        © 2024 MARBEL. Todos los derechos reservados.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PortalInicio'
};
</script>

<style scoped>
/* Estilos adicionales si son necesarios */
</style>
